import Mutations from '../../odata/mutations';

export default { ...new Mutations('pickingListItem'), ...new Mutations('pickingListItems') };
